import React, { forwardRef, useState } from 'react';
import '../../styles/vendorregistration.css';
import { HiOutlineUser } from "react-icons/hi2";
import { MdOutlineEmail } from "react-icons/md";
import { PiDeviceMobileSpeaker } from "react-icons/pi";
import { RiAdminLine } from "react-icons/ri";
import { FiUsers } from "react-icons/fi";
import { useTranslation } from 'react-i18next';
import { countriesData, getCountryByCode } from '../../lists/CountriesData';
import PhoneNumberInput from './PhoneNumberInput';
const RegistrationDetailsPage = forwardRef(({
  formData,
  updateFormData,
  errors,
  handleFieldFocus,
  registerFieldRef
}, ref) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false)
  const [visibleConfirm, setVisibleConfirm] = useState(false)

  const handleChange = (e) => {
    const { id, value } = e.target;
    updateFormData('registrationDetails', id, value);
  };

  const handleTrimBlur = (e) => {
    const { id, value } = e.target;
    const trimmed = typeof value === 'string' ? value.trim() : value;
    updateFormData('registrationDetails', id, trimmed);
  };

  const handleCountryChange = (selectedCountry) => {
    updateFormData('registrationDetails', 'phone_country', selectedCountry);
    updateFormData('registrationDetails', 'phone', '');
  };

  const handlePhoneChange = (phoneNumber) => {
    handleFieldFocus('registrationDetails', 'phone')
    updateFormData('registrationDetails', 'phone', phoneNumber);
  };

  const handleEmgCountryChange = (selectedCountry) => {
    updateFormData('registrationDetails', 'emergency_country', selectedCountry);
    updateFormData('registrationDetails', 'emergency_phone', '');
  };

  const handleEmgPhoneChange = (phoneNumber) => {
    handleFieldFocus('registrationDetails', 'emergency_phone')
    updateFormData('registrationDetails', 'emergency_phone', phoneNumber);

  };

  return (
    <div ref={ref}>
      <h2 className="page-title">{t('vendorRegistration.headers.step1')}</h2>
      <p className="page-description">{t('vendorRegistration.subdescriptions.step1')}</p>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="name">{t('vendorRegistration.formLabels.name')}<span> *</span></label>
          <div className="input-container">
            <input
              type="text"
              id="name"
              maxLength="50"
              placeholder={t('vendorRegistration.placeholders.name')}
              value={formData.registrationDetails.name}
              onChange={(e) => { handleFieldFocus('registrationDetails', 'name'); handleChange(e); }}
              onBlur={handleTrimBlur}
              className={errors.registrationDetails?.name ? 'error' : ''}
              ref={(el) => registerFieldRef('name', el)}
            />
            <div className="input-icon">
              <FiUsers size={20} />
            </div>
          </div>
          {errors.registrationDetails?.name && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.name}`)}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="admin_name">{t('vendorRegistration.formLabels.adminName')}<span> *</span></label>
          <div className="input-container">
            <input
              type="text"
              id="admin_name"
              maxLength="50"
              placeholder={t('vendorRegistration.placeholders.adminName')}
              value={formData.registrationDetails.admin_name}
              onChange={(e) => { handleFieldFocus('registrationDetails', 'admin_name'); handleChange(e); }}
              onBlur={handleTrimBlur}
              className={errors.registrationDetails?.admin_name ? 'error' : ''}
              ref={(el) => registerFieldRef('admin_name', el)}
            />
            <div className="input-icon">
              <RiAdminLine size={20} />
            </div>
          </div>
          {errors.registrationDetails?.admin_name && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.admin_name}`)}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="user_name">{t('vendorRegistration.formLabels.userName')}<span> *</span></label>
          <div className="input-container">
            <input
              type="text"
              id="user_name"
              // disabled={formData.registrationDetails.admin_name==="" || formData.registrationDetails.name==="" ? true : false}
              placeholder={t('vendorRegistration.placeholders.userName')}
              onChange={(e) => {
                handleFieldFocus('registrationDetails', 'user_name');
                const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
                e.target.value = valueWithoutSpaces;
                handleChange(e);
              }}
              value={formData.registrationDetails.user_name}
              onBlur={handleTrimBlur}
              className={errors.registrationDetails?.user_name ? 'error' : ''}
              ref={(el) => registerFieldRef('user_name', el)}
            />
            <div className="input-icon">
              <HiOutlineUser size={22} />
            </div>
          </div>
          {errors.registrationDetails?.user_name && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.user_name}`)}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="email">{t('vendorRegistration.formLabels.email')}<span> *</span></label>
          <div className="input-container">
            <input
              type="email"
              id="email"
              maxLength="50"
              placeholder={t('vendorRegistration.placeholders.email')}
              value={formData.registrationDetails.email}
              onChange={(e) => { handleFieldFocus('registrationDetails', 'email'); handleChange(e); }}
              onBlur={handleTrimBlur}
              className={errors.registrationDetails?.email ? 'error' : ''}
              ref={(el) => registerFieldRef('email', el)}
            />
            <div className="input-icon">
              <MdOutlineEmail />
            </div>
          </div>
          {errors.registrationDetails?.email && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.email}`)}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="phone">{t('vendorRegistration.formLabels.phone')}<span> *</span></label>
          <PhoneNumberInput
            selectedCountry={formData.registrationDetails.phone_country}
            phoneNumber={formData.registrationDetails.phone}
            onCountryChange={handleCountryChange}
            onPhoneChange={handlePhoneChange}
            error={errors.registrationDetails?.phone}
            type='phone'
          />

          {errors.registrationDetails?.phone && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.phone}`)}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="emergency_phone">{t('vendorRegistration.formLabels.emergencyPhone')}</label>
          <PhoneNumberInput
            selectedCountry={formData.registrationDetails.emergency_country}
            phoneNumber={formData.registrationDetails.emergency_phone}
            onCountryChange={handleEmgCountryChange}
            onPhoneChange={handleEmgPhoneChange}
            error={errors.registrationDetails?.emergency_phone}
            type='emergency'
          />
          {errors.registrationDetails?.emergency_phone && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.emergency_phone}`)}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="password">{t('vendorRegistration.formLabels.password')}<span> *</span></label>
          <div className="input-container password-container">
            <input
              type={visibleConfirm ? "text" : "password"}
              id="password"
              placeholder={t('vendorRegistration.placeholders.password')}
              value={formData.registrationDetails.password}
              maxLength="30"
              onChange={(e) => { handleFieldFocus('registrationDetails', 'password'); handleChange(e); }}
              onFocus={() => setVisibleConfirm(true)}
              onBlur={(e) => { setVisibleConfirm(false); handleTrimBlur(e); }}
              className={errors.registrationDetails?.password ? 'error' : ''}
              ref={(el) => registerFieldRef('password', el)}
            />
            <button
              type="button"
              className="password-toggle"
              tabIndex="-1"
              onClick={() => { setVisibleConfirm(!visibleConfirm) }}
            >
              {formData.registrationDetails.password && (
                visibleConfirm ?
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 32 32"><path fill="currentColor" d="m20.523 21.937l7.77 7.77a1 1 0 0 0 1.414-1.414l-26-26a1 1 0 1 0-1.414 1.414l5.156 5.157c-4.116 3.28-5.37 8.242-5.438 8.515l-.003.011a.503.503 0 0 0 .98.22c.068-.29 1.204-5.015 5.146-8.061l3.927 3.926A6 6 0 0 0 9.998 18c0 3.31 2.69 6 6 6c1.804 0 3.425-.8 4.525-2.063m-.708-.708A4.99 4.99 0 0 1 15.998 23c-2.76 0-5-2.24-5-5c0-1.53.688-2.9 1.77-3.816zm-4.262-9.213l1.016 1.016a5.005 5.005 0 0 1 4.397 4.397l1.016 1.016q.016-.22.016-.445a6.005 6.005 0 0 0-6.445-5.984m-4.99-4.99l.76.761C12.669 7.295 14.218 7 15.999 7c10.46 0 12.91 10.18 13.01 10.61c.06.23.26.39.49.39q.021 0 .047-.005q.03-.004.063-.005c.27-.06.44-.33.38-.6v-.004C29.92 17.116 27.19 6 15.997 6c-2.096 0-3.895.39-5.436 1.026"></path></svg>
                  : <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}><path d="M3 13c3.6-8 14.4-8 18 0"></path><path d="M12 17a3 3 0 1 1 0-6a3 3 0 0 1 0 6"></path></g></svg>
              )}
            </button>
          </div>
          {errors.registrationDetails?.password && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.password}`)}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="confirm_password">{t('vendorRegistration.formLabels.confirmPassword')}<span> *</span></label>
          <div className="input-container password-container">
            <input
              type={visible ? "text" : "password"}
              id="confirm_password"
              maxLength="50"
              placeholder={t('vendorRegistration.placeholders.confirmPassword')}
              value={formData.registrationDetails.confirm_password}
              onChange={(e) => { handleFieldFocus('registrationDetails', 'confirm_password'); handleChange(e); }}
              onFocus={() => setVisible(true)}
              onBlur={(e) => { setVisible(false); handleTrimBlur(e); }}
              className={errors.registrationDetails?.confirm_password ? 'error' : ''}
              ref={(el) => registerFieldRef('confirm_password', el)}
            />
            <button
              type="button"
              className="password-toggle"
              tabIndex="-1"
              onClick={() => { setVisible(!visible) }}
            >
              {formData.registrationDetails.confirm_password && (
                visible ?
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 32 32"><path fill="currentColor" d="m20.523 21.937l7.77 7.77a1 1 0 0 0 1.414-1.414l-26-26a1 1 0 1 0-1.414 1.414l5.156 5.157c-4.116 3.28-5.37 8.242-5.438 8.515l-.003.011a.503.503 0 0 0 .98.22c.068-.29 1.204-5.015 5.146-8.061l3.927 3.926A6 6 0 0 0 9.998 18c0 3.31 2.69 6 6 6c1.804 0 3.425-.8 4.525-2.063m-.708-.708A4.99 4.99 0 0 1 15.998 23c-2.76 0-5-2.24-5-5c0-1.53.688-2.9 1.77-3.816zm-4.262-9.213l1.016 1.016a5.005 5.005 0 0 1 4.397 4.397l1.016 1.016q.016-.22.016-.445a6.005 6.005 0 0 0-6.445-5.984m-4.99-4.99l.76.761C12.669 7.295 14.218 7 15.999 7c10.46 0 12.91 10.18 13.01 10.61c.06.23.26.39.49.39q.021 0 .047-.005q.03-.004.063-.005c.27-.06.44-.33.38-.6v-.004C29.92 17.116 27.19 6 15.997 6c-2.096 0-3.895.39-5.436 1.026"></path></svg>
                  : <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}><path d="M3 13c3.6-8 14.4-8 18 0"></path><path d="M12 17a3 3 0 1 1 0-6a3 3 0 0 1 0 6"></path></g></svg>
              )}
            </button>
          </div>
          {errors.registrationDetails?.confirm_password && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.registrationDetails?.confirm_password}`)}</div>
          )}
        </div>
      </div>
    </div>
  );
});

export default RegistrationDetailsPage;